window.sanitasApp = window.sanitasApp || {}
;(function (sanitasApp, window, document) {
  'use strict'

  var toolbarElement = document.getElementsByClassName('js-san-toolbar')[0]
  var toolbarElementIsAbsent = toolbarElement === undefined

  if (toolbarElementIsAbsent) {
    return
  }

  //public interface
  sanitasApp.toolbar = {
    /**
     * checks wether the toolbar has items
     *
     * @return {boolean}
     */
    toolbarIsEmpty() {
      var _count = toolbarElement.querySelectorAll('.toolbar__item')
      return _count.length > 0
    },
  }
})(window.sanitasApp, window, document)
